
/**
 * 分页列表-项
 * @description 自动生成的代码,请勿修改
 */
export default class UiListItem<TKey> {
    constructor() {
        //无参构造函数
    }

    [proName: string]: any;
    /**
     * Id
     */
    Id?: TKey;
}

/**
 * 分页列表-项-表单校验
 */
export const UiListItemRules = {
}
